import { createFileRoute } from '@tanstack/react-router';
import { ContactListPage } from '@/components/contact-list';

export const Route = createFileRoute('/expenses/vendors/')({
  component: () => <ContactListPage kind="vendor" />,
});
